import { FadeLoader } from "react-spinners";

const ProgressSpinner = ({ message }: { message?: string | React.ReactNode }) => {
    return (
        <div className="fixed inset-0 flex items-center justify-center z-[300]">
            <div className="p-5 flex flex-col gap-y-5 items-center justify-center border bg-white min-w-36 min-h-36 rounded-2xl border-gray5">
                <FadeLoader color="#FF7B2E" height={16} margin={6} radius={8} speedMultiplier={1} width={5} />
                {message && <p className="text-sm text-gray-500">{message}</p>}
            </div>
        </div>
    );
};

export default ProgressSpinner;
